import PageHero from "../components/PageHero.jsx";

const interests = [
  "Freeze-dried fruits",
  "Freeze-dried vegetables",
  "Herbs & botanicals",
  "Tea cuts",
  "Functional powders",
  "Private-label sourcing",
  "Custom ingredient request"
];

const inquiryChecklist = [
  "Name",
  "Company",
  "Country",
  "Email",
  "Product Interest",
  "Requirement Details"
];

export default function Contact() {
  const status =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("status") : "";

  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Start the conversation."
        text="Looking for freeze-dried ingredients, tea cuts, botanicals or functional food applications? Let’s connect."
        image="/images/category-tea-cuts.jpg"
      />
      <section className="content-band">
        <div className="section-inner contact-layout">
          <div className="contact-copy">
            <p className="eyebrow">Inquiry brief</p>
            <h2>Contact form fields from the brief.</h2>
            <p>
              Share your requirement details and product interest so we can respond with the right
              sourcing and ingredient direction.
            </p>
            <div className="check-list">
              {inquiryChecklist.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
            <div className="contact-panel">
              <strong>ContiGO Freeze Foods</strong>
              <span>Freeze-dried ingredients for brands thinking ahead.</span>
            </div>
          </div>
          <form className="contact-form" action="/contact-form.php" method="post">
            {status === "sent" && (
              <p className="form-status form-status-success">
                Inquiry sent. Our export team will respond soon.
              </p>
            )}
            {status === "error" && (
              <p className="form-status form-status-error">
                Inquiry could not be sent. Please email Exports@contigofreezefoods.com directly.
              </p>
            )}
            <input type="hidden" name="redirect_to" value="/contact" />
            <label className="form-hp" aria-hidden="true">
              Website
              <input name="website" type="text" tabIndex="-1" autoComplete="off" />
            </label>
            <label>
              Name
              <input name="name" type="text" autoComplete="name" required />
            </label>
            <label>
              Company
              <input name="company" type="text" autoComplete="organization" />
            </label>
            <label>
              Country
              <input name="country" type="text" autoComplete="country-name" required />
            </label>
            <label>
              Email
              <input name="email" type="email" autoComplete="email" required />
            </label>
            <label>
              Product Interest
              <select name="product_interest" defaultValue="">
                <option value="" disabled>
                  Select a category
                </option>
                {interests.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Requirement Details
              <textarea name="requirement_details" rows="6" required />
            </label>
            <button className="button button-primary" type="submit">
              Submit Inquiry
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
